import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/(main)/page.tsx");
